export default "__VITE_ASSET__28231bb9__"